import { Component, Input, OnChanges, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { ChartOptions } from '../../interfaces/chart-options';
import { IProcessCalculationStatistic } from '../../interfaces/process-calculation-statistic.interface';

@Component({
    standalone: false,
    selector: 'app-universal-area-chart',
    templateUrl: './universal-area-chart.component.html',
    styleUrls: ['./universal-area-chart.component.scss']
})
export class UniversalAreaChartComponent implements OnInit, OnChanges {
    chartOptions: Partial<ChartOptions> = {};

    @Input()
    data: IProcessCalculationStatistic[] = [];

    @Input()
    fieldsToShow: string[] = [];

    @Input()
    fieldsLabels?: string[] = [];

    @Input()
    title: string;

    @Input()
    colors?: string[];

    constructor() {}

    ngOnInit(): void {
        this.initChartsOptions();
    }

    ngOnChanges(): void {
        this.initChartsOptions();
    }

    getValueSeries(data: IProcessCalculationStatistic[], fieldName: string) {
        return _.isEmpty(this.data)
            ? []
            : data.map(iteration => {
                  return [iteration.createdAtM.unix() * 1000, iteration[fieldName]];
              });
    }

    initChartsOptions() {
        this.chartOptions = {
            series: this.fieldsToShow.map((fieldName, index) => {
                return {
                    name: !_.isEmpty(this.fieldsLabels)
                        ? this.fieldsLabels[index]
                            ? this.fieldsLabels[index]
                            : fieldName
                        : fieldName,
                    data: this.getValueSeries(this.data, fieldName)
                };
            }),
            chart: {
                type: 'area',
                height: 350,
                stacked: true,
                animations: {
                    enabled: false
                }
            },
            colors: this.colors || ['#008FFB', '#00E396', '#feb019', '#ff4560', '#775dd0'],
            dataLabels: {
                enabled: false
            },
            legend: {
                position: 'top',
                horizontalAlign: 'left'
            },
            xaxis: {
                type: 'datetime'
            },
            title: {
                text: this.title,
                align: 'left',
                offsetX: 7
            },
            grid: {
                padding: {
                    right: 30
                }
            }
        };
    }
}
